/**
 * @generated SignedSource<<f1f885782734c5380ce09e0ae292b047>>
 * @relayHash 0bdc4d1fb20490c2d041b51c72dcb0fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ea2c4b32dcfca804aa2e3ddf6467b7fdad8b0b3e464750b35cd1fddd103059d1

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevOpsMetricsResolutionUnit = "DAY" | "HOUR" | "WEEK" | "%future added value";
export type DevOpsMetricsFilterInput = {
  cloudId: string;
  endAtExclusive: AGG$DateTime;
  issueFilters?: DevOpsMetricsIssueFilters | null | undefined;
  jiraProjectIds?: ReadonlyArray<string> | null | undefined;
  resolution?: DevOpsMetricsResolutionInput | null | undefined;
  startFromInclusive: AGG$DateTime;
  timezoneId?: string | null | undefined;
};
export type DevOpsMetricsIssueFilters = {
  epicIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  issueTypeIds?: ReadonlyArray<string> | null | undefined;
};
export type DevOpsMetricsResolutionInput = {
  unit: DevOpsMetricsResolutionUnit;
  value: number;
};
export type historicalCycleTimeRelayCycleTimeReportQuery$variables = {
  filter: DevOpsMetricsFilterInput;
  isIncludeCycleTimeMean?: boolean | null | undefined;
};
export type historicalCycleTimeRelayCycleTimeReportQuery$data = {
  readonly devOpsMetrics: {
    readonly cycleTime: {
      readonly cycleTimeMetrics: ReadonlyArray<{
        readonly __typename: string;
        readonly aggregateData: AGG$Long | null | undefined;
        readonly data: ReadonlyArray<{
          readonly cycleTimeSeconds: AGG$Long | null | undefined;
          readonly dateTime: AGG$DateTime | null | undefined;
          readonly issuesShippedCount: number | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined> | null | undefined;
      readonly hasPermissionForAllContributingIssues: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type historicalCycleTimeRelayCycleTimeReportQuery = {
  response: historicalCycleTimeRelayCycleTimeReportQuery$data;
  variables: historicalCycleTimeRelayCycleTimeReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isIncludeCycleTimeMean"
  }
],
v1 = [
  {
    "concreteType": "DevOpsMetrics",
    "kind": "LinkedField",
    "name": "devOpsMetrics",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "cycleTimePercentiles",
            "value": [
              50
            ]
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "isIncludeCycleTimeMean",
            "variableName": "isIncludeCycleTimeMean"
          }
        ],
        "concreteType": "DevOpsMetricsCycleTime",
        "kind": "LinkedField",
        "name": "cycleTime",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPermissionForAllContributingIssues"
          },
          {
            "kind": "LinkedField",
            "name": "cycleTimeMetrics",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "concreteType": "DevOpsMetricsCycleTimeData",
                "kind": "LinkedField",
                "name": "data",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "dateTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cycleTimeSeconds"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "issuesShippedCount"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "aggregateData"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "historicalCycleTimeRelayCycleTimeReportQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "historicalCycleTimeRelayCycleTimeReportQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ea2c4b32dcfca804aa2e3ddf6467b7fdad8b0b3e464750b35cd1fddd103059d1",
    "metadata": {},
    "name": "historicalCycleTimeRelayCycleTimeReportQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "82db01bc86598d3f2ad27ee5c52c57c7";

export default node;
